import React from 'react'
import { PropTypes } from 'prop-types'
import { useForm } from 'react-hook-form';


import { Container } from 'react-bootstrap';

import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import ErrorMessage from '../../components/common/ErrorMessage';

import Loading from '../../components/common/Loading';
import { useisLoading } from '../../hook/useisLoading';

export const Email = (props, context) => {

    
    // Hook to show/hide "spinner" while loading page.
    const { isLoading } = useisLoading();

    // Stander useForm of react-hook-form Library
    const { getValues } = useForm({
        defaultValues: {
            
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }
    });

    return <>{(isLoading)?(<Loading/>):( 

        <Container fluid>

            <ErrorMessage message={getValues().backendError}/>

            <PageHeaderStandar title={context.t('Change Email')} subtitle={context.t('Settings')} />

                <h4>Coming soon. </h4>
        </Container>
    )}</>
}

Email.contextTypes = {
    t: PropTypes.func
}

export default Email;